import { useStaticQuery, graphql } from 'gatsby';

const productsQueryWithoutImage = () => {
    const result = useStaticQuery(graphql`
        query ProductStaticQueryWithoutImage {
            allContentfulCategory(sort: {fields: sequence}) {
                nodes {
                    contentful_id
                    url
                    name
                    seo_desc
                    products {
                        name
                        url
                        seo_desc
                        contentful_id
                    }
                }
            }
        }
    `);

    return result.allContentfulCategory.nodes;
};

export default productsQueryWithoutImage;
